import Vue from 'vue'
import Vant from 'vant';
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filter/number'

import 'vant/lib/index.css'
import 'lib-flexible'

import { initSensorsAnalytics } from '@/utils/sensors'

Vue.use(Vant);

Vue.config.productionTip = false;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
initSensorsAnalytics()
// Vue.prototype.F2 = F2

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
